<template>
  <div class="login-page">
    <div class="login-page__shell">
      <div class="login-page__brand">
        <img src="@/assets/img/logo-qupro.png" alt="Qupro" width="180">
      </div>

      <div class="form-card login-page__card">
        <ErrorApi/>

        <div class="form-card__header">
          <h6 class="form-card__title">
            <i class="bi bi-rocket-takeoff"></i>
            ¡Empezá 14 días gratis!
          </h6>
        </div>

        <div class="form-card__body">
          <div v-if="validationErrors.length" class="alert alert-danger" style="font-size: 12px;">
            <ul class="mb-0 pl-3">
              <li v-for="(msg, i) in validationErrors" :key="i">{{ msg }}</li>
            </ul>
          </div>

          <div class="form-card__field">
            <label class="form-card__label" for="reg-company">Empresa</label>
            <input
              id="reg-company"
              v-model.trim="credentials.company"
              type="text"
              class="form-control"
              placeholder="Nombre de la empresa"
              autocomplete="organization"
              required
            >
          </div>

          <div class="form-card__field">
            <label class="form-card__label" for="reg-name">Nombre completo</label>
            <input
              id="reg-name"
              v-model.trim="credentials.name"
              type="text"
              class="form-control"
              placeholder="Nombre completo"
              autocomplete="name"
              required
            >
          </div>

          <div class="form-card__field">
            <label class="form-card__label" for="reg-email">E-mail</label>
            <input
              id="reg-email"
              v-model.trim="credentials.email"
              type="email"
              class="form-control"
              placeholder="tu@email.com"
              autocomplete="email"
              required
            >
          </div>

          <div class="form-card__field">
            <label class="form-card__label" for="reg-password">Contraseña</label>
            <input
              id="reg-password"
              v-model="credentials.password"
              type="password"
              class="form-control"
              placeholder="Contraseña"
              autocomplete="new-password"
              required
            >
          </div>

          <div class="form-card__field login-page__terms">
            Al registrarte aceptás los
            <a href="http://qupro.co/termino-y-condiciones" target="_blank" rel="noopener">términos y condiciones</a>.
          </div>
        </div>

        <div class="form-card__footer login-page__footer">
          <button
            type="button"
            class="form-card__btn form-card__btn--primary login-page__submit"
            @click="register"
          >
            <i class="bi bi-rocket-takeoff"></i>
            ¡Empezar ahora!
          </button>
        </div>
      </div>

      <vue-recaptcha
        ref="recaptcha"
        size="invisible"
        sitekey="6LdA4MUUAAAAABuHm2SpXnTMchR2sKhphqlf_wm6"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
      />

      <div class="login-page__signup">
        ¿Ya estás registrado? <a href="/login">Ingresá acá</a>
      </div>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import ErrorApi from '../global/Errores.vue';

export default {
  components: {
    VueRecaptcha,
    ErrorApi,
  },
  data: function () {
    return {
      errors: {},
      credentials: {
        company: null,
        name: null,
        email: null,
        password: null,
        recaptcha_token: null,
        device: 'qupro-app',
      },
    };
  },
  computed: {
    validationErrors() {
      return Object.values(this.errors).flat();
    },
  },
  methods: {
    register() {
      this.$refs.recaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    onCaptchaVerified(recaptchaToken) {
      this.$refs.recaptcha.reset();
      this.credentials.recaptcha_token = recaptchaToken;
      this.$http.post(process.env.VUE_APP_BASE_URL + '/register', this.credentials)
        .then((response) => {
          if (response.data.message == 'Success') {
            localStorage.setItem('token', response.data.data);
            this.$http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
            window.location.href = '/ventas';
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 422) {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background-color: #4477bd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.login-page__shell {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-page__brand {
  margin-bottom: 24px;
}

.login-page__card {
  width: 100%;
  margin-bottom: 16px;
}

.login-page__terms {
  font-size: 12px;
  color: var(--text-soft);
}

.login-page__terms a {
  color: var(--text);
  text-decoration: underline;
}

.login-page__footer {
  justify-content: stretch;
}

.login-page__submit {
  flex: 1;
  justify-content: center;
}

.login-page__signup {
  font-size: 13px;
  color: #fff;
  text-align: center;
}

.login-page__signup a {
  color: #fff;
  font-weight: 600;
  text-decoration: underline;
}

.login-page__signup a:hover {
  color: rgba(255, 255, 255, 0.85);
}
</style>
